// extracted by mini-css-extract-plugin
export default {"button":"EditTransaction_button__3xDkL","icon":"EditTransaction_icon__DyZtN","edit":"EditTransaction_edit__Oo770","iconMobile":"EditTransaction_iconMobile__psqOc"};